<template>
    <div class="hidden overflow-x-auto md:block">
        <div class="flex w-[1px]">
            <div @click="selectFocusArea(null)" :class="getFocusAreaCss(null)">
                All
            </div>
            <div
                v-for="focusArea in $page.props.focusAreas"
                @click="selectFocusArea(focusArea.id)"
                :class="getFocusAreaCss(focusArea.id)"
            >
                {{ focusArea.title }}
            </div>
        </div>
    </div>
    <div class="md:hidden">
        <new-modal
            title="Filter by Focus Area"
            modal-classes=""
            ref="selectorModal"
        >
            <template #trigger>
                <div
                    class="mx-4 flex items-center justify-between border border-gray-325 px-3 py-2"
                >
                    <div v-if="selectedFocusAreaId">
                        {{ getFocusArea(this.selectedFocusAreaId).title }}
                    </div>
                    <div v-else>All Focus Areas</div>
                    <div class="">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g opacity="0.6">
                                <path
                                    d="M6 9L12 15L18 9"
                                    stroke="#2C354A"
                                    stroke-width="1.91667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
            </template>
            <template #content>
                <div class="flex w-full flex-col bg-white">
                    <div
                        @click="selectFocusArea(null)"
                        :class="
                            'border-b border-gray-325 p-4 hover:cursor-pointer' +
                            ' ' +
                            (!selectedFocusAreaId ? 'bg-gray-325' : 'bg-white')
                        "
                    >
                        All Focus Areas
                    </div>
                    <div
                        v-for="focusArea in $page.props.focusAreas"
                        @click="selectFocusArea(focusArea.id)"
                        :class="
                            'border-b border-gray-325 p-4 hover:cursor-pointer' +
                            ' ' +
                            (selectedFocusAreaId &&
                            selectedFocusAreaId === focusArea.id
                                ? 'bg-gray-325'
                                : 'bg-white')
                        "
                    >
                        <text-clamp
                            :max-lines="1"
                            autoResize
                            :text="focusArea.title"
                        ></text-clamp>
                    </div>
                </div>
            </template>
        </new-modal>
    </div>
</template>
<script>
import Dropdown from "@/Components/Dropdown.vue";
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "StudentTableFocusAreaSelector",
    components: { NewModal, Dropdown },
    emits: ["focus-area-selected"],

    data() {
        return {
            selectedFocusAreaId: null,
        };
    },
    methods: {
        selectFocusArea(focusAreaId) {
            this.selectedFocusAreaId = focusAreaId;
            this.$emit("focus-area-selected", focusAreaId);
            this.$refs.selectorModal.closeModal();
        },
        getFocusAreaCss(focusAreaId) {
            let css =
                "whitespace-nowrap inline-block mr-2 text-[16px] rounded-full border border-gray-400 p-2 px-2.5 text-gray-700 hover:cursor-pointer hover:bg-gray-200";
            if (this.selectedFocusAreaId === focusAreaId) {
                css += " " + "bg-primary-525 hover:bg-primary-600 text-white";
            }

            return css;
        },
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id === focusAreaId;
                }
            );

            return focusArea;
        },
    },
};
</script>
